import MainContent from '@/src/components/organism/MainContent';
import MainHeader from '@/src/components/organism/MainHeader';
import SideNav from '@/src/components/organism/SideNav';
import React from 'react';
import { Outlet } from 'react-router-dom';

function MainLayout() {
  return (
    <div className="flex h-screen min-w-[1250px] flex-col">
      <MainHeader />
      <article className="flex h-full overflow-y-hidden">
        <SideNav />
        <MainContent>
          <Outlet />
        </MainContent>
      </article>
    </div>
  );
}

export default MainLayout;
